export default __webpack_public_path__ + "static/media/arrowup-new.428fa3f4.svg";